<template>
    <header id="header">
        <div class="msite-header">
            <div class="msite-top">
                <div class="msite-left">
                    <div class="msite-click">
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                    <div class="logo">
                        <a :href="$store.state.hrefPrefix + '/'">
                            <img v-if="$store.state.language.code === 'ar'" src="/assets/images/thecradle-ar-logo.svg"
                                 alt=""/>
                            <img v-else-if="$store.state.language.code === 'en'"
                                 src="/assets/images/the-cradle-logo.svg" alt=""/>
                            <img v-else-if="$store.state.language.code === 'tr'"
                                 src="/assets/images/thecradle-tr-logo.svg" alt=""/>
                        </a>
                    </div>
                </div>
                <div class="msite-right">
                    <i class="msite-search"><a :href="$store.state.hrefPrefix + '/search'"><img
                        src="/assets/images/search-icon.svg" alt=""></a></i>

                    <!--                <div class="theme-color-switcher" id="themeColorSwitcher" onclick="toggleThemeColorSwitcher()">-->
                    <!--                    <div class="switcher-container">-->
                    <!--                        <div class="switcher-icon"></div>-->
                    <!--                        <i class="dark-mode"><img src="/assets/images/darkModeIco.svg" alt="dark mode" /></i>-->
                    <!--                        <i class="light-mode"><img src="/assets/images/lightModeIco.svg" alt="light mode" /></i>-->
                    <!--                    </div>-->
                    <!--                </div>-->
                </div>
            </div>
            <div class="msite-subheader">
                <button v-if="$store.state.language.code !== 'tr'" class="msite-support">{{ $t('support_us') }}</button>
                <!--            <span class="translate"><div class="translate-click">-->
                <!--                        <span id=":0.targetLanguage" class="target-language">{{ $t('translate') }} </span>-->
                <!--                    </div></span>-->
            </div>
        </div>
        <div class="container">
            <div class="header">
                <div class="header-top">
                    <div class="header-top-left">
                        <ul class="social-media-style-1">

                            <li v-if="$store.state.language.code === 'ar'">
                                <a href="https://www.facebook.com/thecradlearabi/" target="_blank">
                                    <img src="/assets/images/fb.svg"
                                         onmouseover="this.src='/assets/images/fb-hover.svg'"
                                         onmouseout="this.src='/assets/images/fb.svg'" alt=""/>
                                </a>
                            </li>
                            <li v-else-if="$store.state.language.code === 'tr'">
                                <a href="https://www.facebook.com/profile.php?id=61573869121346" target="_blank">
                                    <img src="/assets/images/fb.svg"
                                         onmouseover="this.src='/assets/images/fb-hover.svg'"
                                         onmouseout="this.src='/assets/images/fb.svg'" alt=""/>
                                </a>
                            </li>
                            <li v-else>
                                <a href="https://www.facebook.com/thecradlemedia/" target="_blank">
                                    <img src="/assets/images/fb.svg"
                                         onmouseover="this.src='/assets/images/fb-hover.svg'"
                                         onmouseout="this.src='/assets/images/fb.svg'" alt=""/>
                                </a>
                            </li>
                            <li v-if="$store.state.language.code === 'ar'">
                                <a href="https://www.instagram.com/thecradlearabi/" target="_blank">

                                    <img src="/assets/images/insta.svg"
                                         onmouseover="this.src='/assets/images/insta-hover.svg'"
                                         onmouseout="this.src='/assets/images/insta.svg'" alt=""/>
                                </a>
                            </li>
                            <li v-else-if="$store.state.language.code === 'tr'">
                                <a href="https://www.instagram.com/cradleturkiye" target="_blank">
                                    <img src="/assets/images/insta.svg"
                                         onmouseover="this.src='/assets/images/insta-hover.svg'"
                                         onmouseout="this.src='/assets/images/insta.svg'" alt=""/>
                                </a>
                            </li>
                            <li v-else>
                                <a href="https://instagram.com/thecradlemedia?igshid=YmMyMTA2M2Y=" target="_blank">

                                    <img src="/assets/images/insta.svg"
                                         onmouseover="this.src='/assets/images/insta-hover.svg'"
                                         onmouseout="this.src='/assets/images/insta.svg'" alt=""/>
                                </a>
                            </li>

                            <li v-if="$store.state.language.code === 'ar'">
                                <a href="https://twitter.com/TheCradleArabi" target="_blank">
                                    <img src="/assets/images/twitter.svg"
                                         onmouseover="this.src='/assets/images/twitter-hover.svg'"
                                         onmouseout="this.src='/assets/images/twitter.svg'" alt=""/>
                                </a>
                            </li>
                            <li v-else-if="$store.state.language.code === 'tr'">
                                <a href="https://x.com/cradleturkiye" target="_blank">
                                    <img src="/assets/images/twitter.svg"
                                         onmouseover="this.src='/assets/images/twitter-hover.svg'"
                                         onmouseout="this.src='/assets/images/twitter.svg'" alt=""/>
                                </a>
                            </li>
                            <li v-else>
                                <a href="https://twitter.com/thecradlemedia" target="_blank">
                                    <img src="/assets/images/twitter.svg"
                                         onmouseover="this.src='/assets/images/twitter-hover.svg'"
                                         onmouseout="this.src='/assets/images/twitter.svg'" alt=""/>
                                </a>
                            </li>
                            <!--                        <li>-->
                            <!--                            <a href="https://chat.whatsapp.com/Bh9zpaIEcsc2axXA4ZQAhy" target="_blank">-->
                            <!--                                <img src="/assets/images/whatsup.svg"-->
                            <!--                                     onmouseover="this.src='/assets/images/whatsup-hover.svg'"-->
                            <!--                                     onmouseout="this.src='/assets/images/whatsup.svg'" alt=""/>-->
                            <!--                            </a>-->
                            <!--                        </li>-->
                            <li v-if="$store.state.language.code === 'ar'">
                                <a href=" https://t.me/thecradlearabi" target="_blank">
                                    <img src="/assets/images/links.svg"
                                         onmouseover="this.src='/assets/images/links-hover.svg'"
                                         onmouseout="this.src='/assets/images/links.svg'" alt=""/>
                                </a>
                            </li>
                            <li v-else-if="$store.state.language.code === 'tr'">
                                <a href="https://t.me/cradleturkiye" target="_blank">
                                    <img src="/assets/images/links.svg"
                                         onmouseover="this.src='/assets/images/links-hover.svg'"
                                         onmouseout="this.src='/assets/images/links.svg'" alt=""/>
                                </a>
                            </li>
                            <li v-else>
                                <a href="https://t.me/thecradlemedia" target="_blank">
                                    <img src="/assets/images/links.svg"
                                         onmouseover="this.src='/assets/images/links-hover.svg'"
                                         onmouseout="this.src='/assets/images/links.svg'" alt=""/>
                                </a>
                            </li>
                            <li>
                                <a :href="$store.state.hrefPrefix +  '/feed'" target="_blank">
                                    <img src="/assets/images/rss-icon.svg"
                                         onmouseover="this.src='/assets/images/rss-icon-hover.svg'"
                                         onmouseout="this.src='/assets/images/rss-icon.svg'" alt=""/>
                                </a>
                            </li>
                        </ul>
                        <ul class="menu-secondary-1">
                            <li v-if="$store.state.language.code !== 'tr'" class="support-click"><a href="#">{{ $t("support_us") }} <i><img
                                src="/assets/images/heart-icon.svg" alt=""/></i></a></li>
                        </ul>
                    </div>
                    <div class="header-top-right">
                        <ul class="menu-secondary-1">
<!--                            <li v-if="$store.state.language.code === 'ar'"><a href="https://thecradle.co">English <i><img src="/assets/images/lung.svg" alt=""/></i></a></li>-->
<!--                            <li v-else><a href="https://thecradlearabic.com">عربي <i><img src="/assets/images/lung.svg" alt=""/></i></a></li>-->
                            <li style="position: relative">
                                <div id="language-dropdown-toggle" @click="toggleElementById('language-dropdown')" class=""
                                     style="display: flex; gap:5px">
                                    <span v-if="$store.state.language.code === 'ar'">عربي</span>
                                    <span v-if="$store.state.language.code === 'en'">English</span>
                                    <span v-if="$store.state.language.code === 'tr'">Türkçe</span>
                                    <img src="/assets/images/lung.svg" alt=""
                                         style="cursor: pointer"/>
                                </div>
                                <div id="language-dropdown" class="opacity-0 pointer-events-none language-dropdown">
                                    <a href="https://thecradle.co">English</a>
                                    <a href="https://thecradlearabic.com">عربي</a>
                                    <a href="https://thecradleturkiye.com">Türkçe</a>
                                </div>
                            </li>
                            <!--                        <li v-if="$store.state.language.code === 'ar'"><a href="https://thecradle.co">English <i><img src="/assets/images/lung.svg" alt=""/></i></a></li>-->
                            <!--                        <li v-else><a href="https://thecradlearabic.com"> <i><img src="/assets/images/lung.svg" alt=""/></i></a></li>-->
                            <template v-if="$store.state.user.id == null">
                                <li><a :href="$store.state.hrefPrefix + '/account/author'">{{ $t('become_an_author') }}
                                    <i><img src="/assets/images/author-icon.svg" alt=""/></i></a></li>
                                <li><a :href="$store.state.hrefPrefix + '/account/login'">{{ $t('Log_in') }} <i><img
                                    src="/assets/images/user-icon.svg" alt=""/></i></a></li>
                            </template>
                            <template v-else>
                                <li><a :href="$store.state.hrefPrefix + '/account/author'">{{ $t('become_an_author') }}
                                    <i><img src="/assets/images/author-icon.svg" alt=""/></i></a></li>
                                <li>
                                    <div class="menu-dropdown">
                                        <span>{{ $t('my_profile') }}  <i><img src="/assets/images/user-icon.svg"
                                                                              alt=""/></i></span>
                                        <ul style="z-index: 99999">
                                            <li><i><img src="/assets/images/Settings-icon.svg" alt=""/></i><a
                                                :href="$store.state.hrefPrefix + '/user/profile'">{{
                                                    $t('profile_settings')
                                                }}</a></li>
                                            <li><i><img src="/assets/images/Comments-icon.svg" alt=""/></i><a
                                                :href="$store.state.hrefPrefix + '/user/comments'">{{
                                                    $t('my_comments')
                                                }}</a></li>
                                            <li class="logout-click"><i><img src="/assets/images/logout-icon.svg"
                                                                             alt=""/></i><a href="#">{{
                                                    $t('log_out')
                                                }}</a></li>
                                        </ul>
                                    </div>
                                </li>
                            </template>

                        </ul>
                    </div>
                </div>


                <div class="logo">
                    <a v-if="$store.state.language.code === 'ar'" :href="$store.state.hrefPrefix + '/'"><img
                        src="/assets/images/thecradle-ar-logo.svg" alt=""/></a>
                    <a v-else-if="$store.state.language.code === 'en'" :href="$store.state.hrefPrefix + '/'"><img
                        src="/assets/images/the-cradle-logo.svg" alt=""/></a>
                    <a v-else-if="$store.state.language.code === 'tr'" :href="$store.state.hrefPrefix + '/'"><img
                        src="/assets/images/thecradle-tr-logo.svg" alt=""/></a>
                </div>
            </div>
        </div>
    </header>
</template>

<script>
export default {
    name: "TopBarRight",
    methods: {
        toggleElementById(Id) {
            const dropDown = document.getElementById(Id);
            dropDown.classList.toggle('opacity-0');
            dropDown.classList.toggle('pointer-events-none');
        }
        ,
        handleClickAway(event) {
            const element = document.getElementById('language-dropdown-toggle')
            const dropDown = document.getElementById('language-dropdown');
            if (element && !element.contains(event.target) && !dropDown.contains(event.target)) {
                dropDown.classList.add('opacity-0');
                dropDown.classList.add('pointer-events-none');
            }
        },
    },
    mounted() {
        document.addEventListener('click', this.handleClickAway);
    },
    beforeDestroy() {
        document.removeEventListener('click', this.handleClickAway);
    },
}

</script>

<style scoped>
.translate-click, .translate {
    background-image: none !important;
}

.opacity-0 {
    opacity: 0;
}

.pointer-events-none {
    pointer-events: none;
}

.language-dropdown {
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
    position: absolute;
    padding: 10px 0;
    box-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
}

.language-dropdown a {
    display: block;
    color: #000;
    text-decoration: none;
    padding: 8px 12px;
}

.language-dropdown a:hover {
    background-color: #a40404;
    color: white;
}
</style>

